import * as React from 'react';
import classnames from 'classnames';

import { NUM_POSTS_TO_SHOW, getLoadingImages } from '../../utils/tile-standard';

import '../../content/tile-standard-content.scss';
import '../../content/details/tile-standard-content-details.scss';
import '../../content/details/section/tile-standard-content-details-section.scss';
import '../../channels/tile-standard-content-channels.scss';
import '../../carousel/tile-standard-carousel.scss';
import '../../carousel/item/tile-standard-carousel-item.scss';
import './tile-standard-loading-content.scss';

import type { TileStandardSize } from 'types';

type Props = {
  tileSize: TileStandardSize
};

const TileStandardLoadingContent = (
  {
    tileSize
  }: Props
): JSX.Element => {
  const renderItem = (index: number): JSX.Element => {
    const labelClasses = classnames('tile-standard-content-details-section__label',
      'tile-standard-loading-content-details-section__label', {
        [`tile-standard-loading-content-details-section__label--${index}`]: index >= 0
      }
    );

    const valueClasses = classnames('tile-standard-content-details-section__value',
      'tile-standard-loading-content-details-section__value', {
        [`tile-standard-loading-content-details-section__value--${index}`]: index >= 0
      }
    );

    return (
      <div
        key={`tile-standard-content-details-section--${index}`}
        className="tile-standard-content-details-section tile-standard-loading-content-details-section"
      >
        <div className={labelClasses} />
        <div className={valueClasses} />
      </div>
    );
  };

  const containerClasses = classnames('tile-standard-content', {
    [`tile-standard-loading-content--size-${tileSize}`]: tileSize
  });

  return (
    <div className={containerClasses}>
      <div className="tile-standard-content-channels tile-standard-content-channels--show">
        <div className="tile-standard-content-channels__details">
          <div className="tile-standard-content-details tile-standard-loading-content-details">
            <div className="tile-standard-content-details__container">
              {[0, 1, 2, 3].map(renderItem)}
            </div>
          </div>
        </div>
        <div className="tile-standard-content-channels__carousel">
          <div className="tile-standard-carousel">
            {
              getLoadingImages(NUM_POSTS_TO_SHOW.standard).map((item, index) => (
                <div
                  key={`tile-standard-carousel-item--${item.type}-${index}`}
                  className="tile-standard-carousel-item tile-standard-carousel-item--is-loading tile-standard-carousel-item--type-standard"
                >
                  <div className="tile-standard-carousel-item__content tile-standard-loading-carousel-item__content" />
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default TileStandardLoadingContent;
